var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import VueDialog from "../../../interface/IVueDialog";
import Uploader from "../../../common/components/uploader";
import LicenseFileList from "../../licenseManage/components/LicenseFileList";
var OrderPicDialog = (function (_super) {
    __extends(OrderPicDialog, _super);
    function OrderPicDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.picsInner = [];
        return _this;
    }
    OrderPicDialog.prototype.mounted = function () {
        if (this.pics) {
            this.picsInner = JSON.parse(JSON.stringify(this.pics));
        }
    };
    OrderPicDialog.prototype.close = function () {
        this.$closeDialog();
    };
    OrderPicDialog.prototype.save = function () {
        if (this.pageType !== 'see') {
            this.$emit("submit", this.picsInner);
        }
        this.close();
    };
    OrderPicDialog = __decorate([
        Component({
            components: {
                uploader: Uploader,
                LicenseFileList: LicenseFileList
            }
        })
    ], OrderPicDialog);
    return OrderPicDialog;
}(VueDialog));
export default OrderPicDialog;
